/**
 * Набор констант для z-index соответствующих классов компонентов.
 * Значения выбраны по приоритету. Например, модальное окно с оверлеем должно всегда быть выше других компонентов.
 */
export const stackingOrder = {
    /**
     * Для компонентов с возможностью фокуса: кнопки, поля ввода
     */
    FOCUSED: 2,
    /**
     * Значение по-умолчанию
     */
    DEFAULT: 5,
    /**
     * Компоненты, которые управляют своей позицией, например, тултипы
     */
    POSITIONER: 20,
    /**
     * Для модальных окон с оверлеем
     */
    OVERLAY: 30,
};

export const config = {
    stackingOrder,
};
